import React from "react";
import Button from "@mui/material/Button";
import styles from "./termsDeclined.module.scss";
import "../../styles/sharedStyles.scss";
import FordLogo from "../../common/FordLogo";
import HasPermissionTo from "../../common/HasPermissionTo";
import PageHeader from "../../shared/pageHeader/PageHeader";
import { withTranslation } from "react-i18next";
import { IS_SA_MARKET } from "../../utils/EmpUtil";

const TermsDeclined = (props) => {
  return (
    <div className="pageWrapper">
      <PageHeader {...props} title={props.t("TermsDeclined.header")} />
      <div className={styles.center}>
        <FordLogo className={styles.brandLogo} />
        <div className={`${styles.declinedTitle}`}>
          {props.t("TermsDeclined.header")}
        </div>
      </div>

      <HasPermissionTo
        permissions={props.user.permissions.rolePermissions}
        perform={["deniedSteps:view"]}
        render={() => (
          <>
            <div className={styles.declinedSubheader}>
              {props.t("TermsDeclined.subheader")}
            </div>
            {!IS_SA_MARKET(props.user.market) && (
              <div className={styles.lineTextHeader}>
                <div>
                  <span className="lineNumber">1 </span>
                  <span className="lineText">
                    {" "}
                    {props.t("OnboardingWelcome.stepOne")}
                  </span>
                </div>
                <div>
                  <span className="lineNumber">2 </span>
                  <span className="lineText">
                    {" "}
                    {props.t("OnboardingWelcome.stepTwo")}
                    <span className={styles.normalFontWeight}>
                      {" "}
                      {props.t("OnboardingWelcome.stepTwoSub")}{" "}
                    </span>
                  </span>
                </div>
                <div>
                  <span className="lineNumber">3 </span>
                  <span className="lineText">
                    {" "}
                    {props.t("OnboardingWelcome.stepThree")}
                  </span>
                </div>
              </div>
            )}
          </>
        )}
        noRender={() => {
          return (
            <div className={styles.center}>
              <span className="lineText">
                {" "}
                {props.t("OnboardingWelcome.acceptTerms")}
              </span>
            </div>
          );
        }}
      />
      <div className="confirmButton">
        <Button
          className="quickStart"
          type="button"
          onClick={props.onDecline}
          id="start-action-onboard-btn"
        >
          {props.t("OnboardingWelcome.getStarted")}
        </Button>
      </div>
    </div>
  );
};

export default withTranslation("emp")(TermsDeclined);
